import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';

@Injectable()
export class InjectionService {

  constructor(private http: HttpClient) { }

  realise(start, end, injecteur, uri, callback): Promise<any> {
    return  new Promise((resolve, reject) => {
      this.http.post(`${environment.api.myshiftUrl}/tma/${uri}?start=${start}&end=${end}&injecteur=${injecteur}`, {})
      .subscribe((vo: any) => {
        resolve(vo);
      }, error => {
        callback();
        resolve(error);
      }, () => {
        callback();
      });
    });
  }

  downloadFile(csvData, filename='data') {
    console.log(csvData)
    let blob = new Blob(['\ufeff' + csvData], { type: 'text/csv;charset=utf-8;' });
    let dwldLink = document.createElement('a');
    let url = URL.createObjectURL(blob);
    let isSafariBrowser = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;
    if (isSafariBrowser) {  // if Safari open in new window to save file with random filename.
        dwldLink.setAttribute('target', '_blank');
    }
    dwldLink.setAttribute('href', url);
    dwldLink.setAttribute('download', filename + '.csv');
    dwldLink.style.visibility = 'hidden';
    document.body.appendChild(dwldLink);
    dwldLink.click();
    document.body.removeChild(dwldLink);
}

}



// WEBPACK FOOTER //
// ./src/app/service/injection.service.ts